import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import VELogo from "./VELogo";

const links = [
  { to: "/", label: "Home" },
  { to: "/category/switches", label: "Switches" },
  { to: "/category/leds", label: "LEDs" },
  { to: "/category/fans", label: "Fans" },
  { to: "/category/mcb", label: "MCB" },
  { to: "/category/wires", label: "Wires" },
  { to: "/category/automation", label: "Automation" },
  { to: "/boq", label: "Get Quote" },
  { to: "/about", label: "About" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-slate-900 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-12">
        <Link
          to="/"
          className="flex items-center gap-2 text-white"
          data-testid="nav-logo"
          onClick={() => setOpen(false)}
        >
          <VELogo size={28} />
          <span className="font-heading font-semibold text-base tracking-tight">
            Veer Electrical
          </span>
        </Link>

        {/* Desktop menu */}
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `px-3 py-1.5 text-sm font-medium rounded-full transition-colors ${
                  isActive
                    ? "bg-white text-slate-900"
                    : "text-slate-200 hover:bg-slate-800 hover:text-white"
                }`
              }
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="https://wa.me/917400042543"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-3 py-1.5 bg-amber-500 text-slate-900 font-medium rounded-full text-sm hover:bg-amber-400 transition-colors"
            data-testid="nav-whatsapp"
          >
            <Phone className="w-4 h-4" />
            <span className="hidden sm:inline">WhatsApp</span>
          </a>
          {/* Mobile hamburger */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden p-2 -mr-2 text-white hover:bg-slate-800 rounded-lg"
            data-testid="nav-mobile-toggle"
            aria-label="Open menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <nav
          className="md:hidden border-t border-slate-800 bg-slate-900"
          data-testid="nav-mobile-menu"
        >
          <div className="max-w-7xl mx-auto px-4 py-3 grid grid-cols-2 gap-2">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-2.5 text-sm font-medium rounded-xl transition-colors text-center ${
                    isActive
                      ? "bg-white text-slate-900"
                      : "bg-slate-800/60 text-slate-100 hover:bg-slate-800"
                  }`
                }
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}
